import { seoOgIsActive } from './SeoStore';

export const updateSeoOgIsActive = (value) => seoOgIsActive.update(oldValue => value);
